// @flow
import apiRequest from '../../stores/ApiService';

const getCartCount = (baseApiUrl: string, storeCode: string) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/cart?storeCode=${storeCode}`,
  })
    .then((response) => (response.ok ? response.text() : null))
    .then((count) => parseInt(count || 0, 10));

export default {
  getCartCount,
};
